// @flow
import React, {PureComponent} from 'react';
import classNames from 'classnames';
import {convertPxToRem} from '@pb/kit-util-convert-px-to-rem';

import {tableRowName} from './constants';

type Props = {|
    height: number,
    id?: string,
    mix: string,
|};

class DataTableRowPlaceholder extends PureComponent<Props> {
    static defaultProps = {
        id: ''
    };

    render() {
        const {height, id, mix} = this.props;
        const styles = {'--row-height': convertPxToRem(height)};

        return (
            <div id={id} className={classNames(tableRowName, mix)} style={styles}/>
        );
    }
}

export {DataTableRowPlaceholder};
